module.exports = __webpack_public_path__ + "static/media/a2.8ba57b90.png";